export const formatCurrency = (amount: number): string => {
    if (typeof amount === 'number') {
        const formattedAmount = (Math.abs(amount) / 100).toFixed(2);
        return amount < 0 ? `-$${formattedAmount}` : `$${formattedAmount}`;
    }
    return "$ --"
};

export const formatDate = (dateString: string): string => {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
    });
};

export function getIntegerAmount(displayAmount: string) {
    displayAmount = displayAmount.replace(/\$/g, '')
    if (displayAmount.length == 0) {
        return 0
    }
    let [integerPart, decimalPart] = displayAmount.split('.');
    if (decimalPart) {
        if (decimalPart.length < 2) {
            decimalPart = decimalPart + '0'
        }
        return parseInt(integerPart) * 100 + parseInt(decimalPart)
    } else {
        return parseInt(integerPart) * 100
    }
}

export const getDisplayAmount = (value: string) => {
    const cleanedValue = value.replace(/[^0-9.]/g, '');
    if (cleanedValue.length === 0) {
        return ''
    }
    if (cleanedValue.length > 1 && cleanedValue[0] === '0' && cleanedValue[1] !== '.') {
        console.log('1')
        return '$' + cleanedValue[1]
    }
    if (!cleanedValue.includes('.')) {
        return '$' + cleanedValue
    }
    let [integerPart, decimalPart] = cleanedValue.split('.');
    if (!integerPart) {
        integerPart = '0'
    }
    let result = `${integerPart}.`
    if (decimalPart) {
        if (decimalPart.length > 2) {
            decimalPart = decimalPart.slice(0, 2)
        }
        result = result + decimalPart
    }
    return '$' + result
};
